import { UserAdminApiResponse } from './../models/user-admin-api-response';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsrInfo, UsrInfoC } from '../models/usr-info.model';
import { catchError } from 'rxjs/operators';
import { Branch } from './../models/branch.model';
import { Role } from './../models/role.model';

@Injectable({
  providedIn: 'root'
})
export class UserAdminService {
  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService
  ) {}

  getUsers(
    page?: number,
    limit?: number,
    sort?: string,
    viewOnlyActive?: boolean
  ): Observable<UserAdminApiResponse> {
    const url = `${this.baseService.hostDomain}/api/useradmin`;
    const data: any = {};
    if (page) {
      data.page = page;
    }
    if (limit) {
      data.limit = limit;
    }
    if (sort) {
      data.sort = sort;
    }
    if (viewOnlyActive) {
      data.viewOnlyActive = viewOnlyActive;
    }
    return this.httpClient
      .get<UserAdminApiResponse>(url, { params: data })
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Buscando los usuarios');
          return [];
        })
      );
  }

  saveUser(user: UsrInfo): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/useradmin`;
    return this.httpClient.post<boolean>(url, { email: user.email }).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Creando un nuevo usuario`);
        return [];
      })
    );
  }

  saveUserInfo(roles: string[], branches: string[], email: string) {
    const url = `${this.baseService.hostDomain}/api/userrole`;
    const data: any = {};
    data.email = email;
    data.branches = branches;
    data.roles = roles;
    return this.httpClient.post(url, data).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Guardando el usuario ${email}`);
        return [];
      })
    );
  }

  updateUserInfo(email: string, status: string, userName: string, city: string, office: string) {
    const url = `${this.baseService.hostDomain}/api/useradmin`;
    const data: any = {};
    data.email = email;
    data.status = status;
    data.userName = userName;
    data.city = city;
    data.office = office;
    return this.httpClient.post(url, data).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Guardando el usuario ${email}`);
        return [];
      })
    );
  }
}
